import { render, staticRenderFns } from "./classType.vue?vue&type=template&id=ff1b3d02&scoped=true&"
import script from "./classType.vue?vue&type=script&lang=js&"
export * from "./classType.vue?vue&type=script&lang=js&"
import style0 from "./classType.vue?vue&type=style&index=0&id=ff1b3d02&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff1b3d02",
  null
  
)

export default component.exports